import { Service } from '@tencent/workbench';
import { IBaseMobileContextMenuService } from '@framework/workbench/interfaces/base-mobile-context-menu-service.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';

@Service({
    provide: IBaseMobileContextMenuService,
})
export default class BaseMobileContextMenuFeature {
    public id = ''; // 子类需要获取自己的id

    public getModel() {
        let model: any = null;
        const selectedMgrRef = this.getSelectionService().selectedElements;
        if (selectedMgrRef) {
            const len = selectedMgrRef.length;
            if (len === 1) {
                model = selectedMgrRef.selectedArray?.[0];
            }
        }
        return model;
    }

    public get editorInstance() {
        const model = this.getSelectionService().selectedElements.getCurrentModel();
        if (model.type === UIModelType.NOTE) {
            return model?.noteTextBody?.editorInstance;
        }
        return model?.editorInstance;
    }

    public getSelectionService(): ISelectionService {
        return this.getAppServices().viewableServiceLayer.selectionService;
    }

    public getUiDataService(): IUiDataService {
        return this.getAppServices().getUiDataService();
    }

    public getAppServices(): IMobileEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IMobileEditorAppServices;
    }
}
